// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e5487946","239":"04c767de","455":"8de130a0"}[chunkId] + ".chunk.js";
};